module.exports = __webpack_public_path__ + "img/ico-lnk.f026e172.svg";